var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.readonly || _vm.disabled) ? _c('div', [_vm._v(_vm._s(_vm.inputValue))]) : _c('div', {
    ref: "dropRef",
    staticClass: "ivu-select ivu-select-single ivu-select-default option-box"
  }, [(_vm.multiple) ? _c('div', {
    style: (("width: " + (_vm.width||'210px') + ";")),
    on: {
      "mouseover": function($event) {
        (_vm.values.length || _vm.constValues.length || _vm.content) ? _vm.isDeleteButton = true: _vm.isDeleteButton = false
      },
      "mouseleave": function($event) {
        _vm.isDeleteButton = false
      }
    }
  }, [_c('div', {
    ref: "multipleR",
    staticClass: "ivu-select-selection",
    staticStyle: {
      "height": "auto",
      "min-height": "32px !important",
      "padding": "0 0 0 5px"
    },
    on: {
      "click": _vm.selectUp
    }
  }, [(_vm.values.length == 1) ? _c('Tag', {
    attrs: {
      "closable": ""
    },
    on: {
      "on-close": function($event) {
        return _vm.handleClose()
      }
    }
  }, [_vm._v(_vm._s(_vm.values[0].name))]) : _vm._e(), _vm._v(" "), (_vm.values.length > 1) ? _c('Tag', [_vm._v("已选" + _vm._s(_vm.values.length) + "项")]) : _vm._e(), _vm._v(" "), (_vm.constValues.length == 1) ? _c('Tag', {
    attrs: {
      "closable": ""
    },
    on: {
      "on-close": function($event) {
        return _vm.handleClose()
      }
    }
  }, [_vm._v(_vm._s(_vm.constValues[0].name))]) : _vm._e(), _vm._v(" "), (_vm.constValues.length > 1) ? _c('Tag', [_vm._v("已选" + _vm._s(_vm.constValues.length) + "项")]) : _vm._e(), _vm._v(" "), (!_vm.options || _vm.options.length == 0) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    ref: "inputVal",
    staticClass: "ivu-select-input",
    staticStyle: {
      "padding": "0 0 0 4px"
    },
    style: (_vm.inputStyle),
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "onautocomplete": "off",
      "placeholder": _vm.values.length ? '' : _vm.placeholder
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "keyup": _vm.selectKeyDown,
      "compositionstart": function($event) {
        _vm.flag = false
      },
      "compositionend": function($event) {
        _vm.flag = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.options && _vm.options.length > 0) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.constinputValue),
      expression: "constinputValue"
    }],
    ref: "inputVal",
    staticClass: "ivu-select-input",
    staticStyle: {
      "padding": "0 0 0 4px"
    },
    style: (_vm.inputStyle),
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "onautocomplete": "off",
      "placeholder": _vm.constValues.length ? '' : _vm.placeholder
    },
    domProps: {
      "value": (_vm.constinputValue)
    },
    on: {
      "keyup": _vm.shopInput,
      "compositionstart": function($event) {
        _vm.flag = false
      },
      "compositionend": function($event) {
        _vm.flag = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.constinputValue = $event.target.value
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "delete-selected",
    staticStyle: {
      "top": "10px"
    },
    on: {
      "click": _vm.selectUp
    }
  }, [_c('Icon', {
    staticStyle: {
      "margin-left": "4px"
    },
    attrs: {
      "type": _vm.contentShow ? 'ios-arrow-up' : 'ios-arrow-down',
      "size": "14",
      "color": "#808695"
    }
  })], 1), _vm._v(" "), (_vm.clear && _vm.isDeleteButton) ? _c('span', {
    staticClass: "delete-selected",
    on: {
      "click": function($event) {
        return _vm.deleteButtonClick()
      }
    }
  }, [_c('Icon', {
    staticStyle: {
      "margin-left": "4px"
    },
    attrs: {
      "type": "ios-close-circle",
      "size": "14",
      "color": "#5C6B77"
    }
  })], 1) : _vm._e()]) : _c('div', {
    staticClass: "ivu-select-selection ",
    style: (("width: " + (_vm.width||'200px') + ";")),
    on: {
      "mouseover": function($event) {
        (_vm.inputValue || _vm.content) ? _vm.isDeleteButton = true: _vm.isDeleteButton = false
      },
      "mouseleave": function($event) {
        _vm.isDeleteButton = false
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    staticClass: "ivu-select-input",
    attrs: {
      "id": "tentant-input",
      "type": "text",
      "autocomplete": "off",
      "onautocomplete": "off",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "click": _vm.selectUp,
      "keyup": _vm.selectKeyDown,
      "compositionstart": function($event) {
        _vm.flag = false
      },
      "compositionend": function($event) {
        _vm.flag = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "delete-selected",
    on: {
      "click": _vm.selectUp
    }
  }, [_c('Icon', {
    staticStyle: {
      "margin-left": "4px"
    },
    attrs: {
      "type": _vm.contentShow ? 'ios-arrow-up' : 'ios-arrow-down',
      "size": "14",
      "color": "#808695"
    }
  })], 1), _vm._v(" "), (_vm.clear && _vm.isDeleteButton) ? _c('span', {
    staticClass: "delete-selected",
    on: {
      "click": function($event) {
        return _vm.deleteButtonClick()
      }
    }
  }, [_c('Icon', {
    staticStyle: {
      "margin-left": "4px"
    },
    attrs: {
      "type": "ios-close-circle",
      "size": "14",
      "color": "#5C6B77"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', [(!_vm.options || _vm.options.length == 0) ? _c('div', [(_vm.contentShow) ? _c('div', {
    directives: [{
      name: "loadmore",
      rawName: "v-loadmore",
      value: ({
        loadMore: _vm.loadMoreGroup
      }),
      expression: "{loadMore:loadMoreGroup}"
    }],
    staticClass: "ivu-select-dropdown selected-content",
    style: ({
      top: (_vm.multiple ? _vm.paddTop + 'px' : '30px')
    }),
    attrs: {
      "id": "selected-content"
    }
  }, [_c('ul', {
    staticClass: "el-scrollbar__view ivu-select-dropdown-list ul-content"
  }, [_vm._l((_vm.contentOptions), function(i, index) {
    return _c('li', {
      key: index,
      staticClass: "ivu-select-item option-item",
      class: {
        selected: _vm.multiple ? _vm.values.some(function (row) { return (row._id || row.code) == (i._id || i.code); }) : index === _vm.current
      },
      on: {
        "click": function($event) {
          return _vm.contentClick(i, index)
        }
      }
    }, [_c('div', [_c('p', {
      staticClass: "nowrap",
      style: (("max-width: " + _vm.selectionWidth + "px;"))
    }, [_vm._v(_vm._s(i.name))]), _vm._v(" "), _c('p', {
      staticClass: "nowrap",
      staticStyle: {
        "color": "#ccc"
      }
    }, [_vm._v(_vm._s(i.code))])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.multiple && _vm.values.some(function (row) { return (row._id || row.code) == (i._id || i.code); })),
        expression: "multiple && values.some(row=>(row._id||row.code) == (i._id||i.code))"
      }]
    }, [_c('Icon', {
      attrs: {
        "type": "ios-checkmark",
        "size": "24",
        "color": "rgba(32, 191, 100, 0.9)"
      }
    })], 1)])
  }), _vm._v(" "), _c('li', {
    staticClass: " hint jcsb"
  }, [_c('span', [_vm._v("共 "), _c('span', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v(_vm._s(_vm.totalTenants))]), _vm._v(" 条结果")])])], 2), _vm._v(" "), (_vm.contentOptions.length === 0 && !_vm.loading) ? _c('p', {
    staticClass: "tip-class"
  }, [_vm._v("暂无数据")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('p', {
    staticClass: "tip-class"
  }, [_vm._v("数据加载中...")]) : _vm._e()]) : _vm._e()]) : _c('div', [(_vm.contentShow) ? _c('div', {
    staticClass: "ivu-select-dropdown selected-content",
    style: ({
      top: (_vm.multiple ? _vm.paddTop + 'px' : '30px')
    }),
    attrs: {
      "id": "selected-content"
    }
  }, [_c('ul', {
    staticClass: "el-scrollbar__view ivu-select-dropdown-list ul-content"
  }, [_vm._l((_vm.fixationOptions), function(i, index) {
    return _c('li', {
      key: index,
      staticClass: "ivu-select-item option-item",
      class: {
        selected: _vm.multiple ? _vm.constValues.some(function (row) { return row.name == i.name; }) : index === _vm.current
      },
      on: {
        "click": function($event) {
          return _vm.constClick(i, index)
        }
      }
    }, [_c('div', [_c('p', {
      staticClass: "nowrap",
      staticStyle: {
        "max-width": "200px"
      }
    }, [_vm._v(_vm._s(i.name))])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.multiple && _vm.constValues.some(function (row) { return row.name == i.name; })),
        expression: "multiple && constValues.some(row=>row.name == i.name)"
      }]
    }, [_c('Icon', {
      attrs: {
        "type": "ios-checkmark",
        "size": "24",
        "color": "rgba(32, 191, 100, 0.9)"
      }
    })], 1)])
  }), _vm._v(" "), _c('li', {
    staticClass: " hint jcsb"
  }, [_c('span', [_vm._v("共 "), _c('span', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v(_vm._s(_vm.fixationOptions.length))]), _vm._v(" 条结果")])])], 2)]) : _vm._e()])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a3ad24b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseSelect/index.vue
// module id = ScHn
// module chunks = 142